import React, { Component } from "react";
import "./style.css";

class GetinTouch extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    lastname: "",
    events: "",
    notes: "",
    error: {},
  };

  changeHandler = (e) => {
    const error = { ...this.state.error };
    error[e.target.name] = "";

    this.setState({
      [e.target.name]: e.target.value,
      error,
    });
  };

  submitHandler = (e) => {
    e.preventDefault();

    const { name, email, phone, lastname, events, notes, error } = this.state;

    // Validation
    if (name === "") {
      error.name = "Please enter your name";
    }
    if (email === "") {
      error.email = "Please enter your email";
    }
    if (phone === "") {
      error.phone = "Please enter your phone";
    }
    if (lastname === "") {
      error.lastname = "Please enter your lastname";
    }
    if (events === "") {
      error.events = "Select your event list";
    }
    if (notes === "") {
      error.notes = "Please enter your note";
    }

    this.setState({ error });

    // Check if all errors are cleared
    if (Object.values(error).every((err) => err === "")) {
      this.setState({
        name: "",
        email: "",
        phone: "",
        lastname: "",
        events: "",
        notes: "",
        error: {},
      });
    }
  };

  render() {
    const { name, email, phone, error } = this.state;

    return (
      <div className="question-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="wpo-section-title">
                <h2>Do You Have Any Question?</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="question-touch">
                <h2>Get In Touch</h2>
                <form onSubmit={this.submitHandler}>
                  <div className="half-col">
                    <input
                      value={name}
                      onChange={this.changeHandler}
                      type="text"
                      name="name"
                      placeholder="Name"
                    />
                    <p>{error.name ? error.name : ""}</p>
                  </div>
                  <div className="half-col">
                    <input
                      onChange={this.changeHandler}
                      value={email}
                      type="email"
                      name="email"
                      placeholder="Email"
                    />
                    <p>{error.email ? error.email : ""}</p>
                  </div>
                  <div className="half-col">
                    <input
                      onChange={this.changeHandler}
                      value={phone}
                      type="text"
                      name="phone"
                      placeholder="Phone"
                    />
                    <p>{error.phone ? error.phone : ""}</p>
                  </div>
                  <div className="half-col">
                    <input
                      onChange={this.changeHandler}
                      value={this.state.lastname}
                      type="text"
                      name="lastname"
                      placeholder="Lastname"
                    />
                    <p>{error.lastname ? error.lastname : ""}</p>
                  </div>
                  <div className="half-col">
                    <select
                      onChange={this.changeHandler}
                      value={this.state.events}
                      name="events"
                    >
                      <option value="">Select an Event</option>
                      <option value="Event 1">Event 1</option>
                      <option value="Event 2">Event 2</option>
                    </select>
                    <p>{error.events ? error.events : ""}</p>
                  </div>
                  <div>
                    <textarea
                      className="form-control"
                      name="notes"
                      value={this.state.notes}
                      onChange={this.changeHandler}
                      placeholder="Your Question"
                    ></textarea>
                    <p>{error.notes ? error.notes : ""}</p>
                  </div>
                  <div className="submit-btn-wrapper">
                    <button type="submit" className="theme-btn">
                      Submit Now
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GetinTouch;
